

import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function ClientPortfolio() {
  const [clientData, setClientData] = useState<any>(null);
  const [activeFilter, setActiveFilter] = useState('all');
  const navigate = useNavigate();

  useEffect(() => {
    const isAuthenticated = localStorage.getItem('isAuthenticated');
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }

    const data = localStorage.getItem('clientData');
    if (data) {
      setClientData(JSON.parse(data));
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('clientData');
    navigate('/');
  };

  const portfolioItems = [
    {
      id: 1,
      title: 'Backyard Renovation - Before',
      project: 'Backyard Renovation',
      category: 'landscape',
      date: '2024-01-15',
      image: 'https://public.readdy.ai/ai/img_res/db652e3efc3d6dbff7d91ba7d05a1c20.jpg',
      description: 'Initial state of backyard before renovation work began'
    },
    {
      id: 2,
      title: 'Backyard Renovation - Progress',
      project: 'Backyard Renovation',
      category: 'landscape',
      date: '2024-01-20',
      image: 'https://readdy.ai/api/search-image?query=Backyard%20renovation%20in%20progress%2C%20construction%20work%2C%20landscaping%20progress%2C%20patio%20installation%2C%20garden%20transformation%20work&width=400&height=300&seq=39&orientation=landscape',
      description: 'Patio installation and initial landscaping work in progress'
    },
    {
      id: 3,
      title: 'Front Yard Landscaping - Final Result',
      project: 'Front Yard Landscaping',
      category: 'landscape',
      date: '2023-12-15',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20front%20yard%20landscaping%20completed%2C%20lush%20green%20grass%2C%20professional%20landscape%20design%2C%20curb%20appeal%20improvement%2C%20finished%20garden%20project&width=400&height=300&seq=40&orientation=landscape',
      description: 'Completed front yard landscaping with new plantings and walkway'
    },
    {
      id: 4,
      title: 'Front Yard - Before Transformation',
      project: 'Front Yard Landscaping',
      category: 'landscape',
      date: '2023-11-01',
      image: 'https://readdy.ai/api/search-image?query=Front%20yard%20before%20landscaping%2C%20plain%20lawn%2C%20needs%20improvement%2C%20before%20transformation%2C%20basic%20outdoor%20space&width=400&height=300&seq=41&orientation=landscape',
      description: 'Original front yard before landscaping improvements'
    },
    {
      id: 5,
      title: 'Kitchen Addition - Foundation',
      project: 'Kitchen Addition',
      category: 'construction',
      date: '2024-01-10',
      image: 'https://readdy.ai/api/search-image?query=House%20addition%20foundation%20work%2C%20construction%20site%2C%20building%20foundation%2C%20residential%20construction%2C%20home%20extension%20project&width=400&height=300&seq=42&orientation=landscape',
      description: 'Foundation work for kitchen addition project'
    },
    {
      id: 6,
      title: 'Patio Installation Detail',
      project: 'Backyard Renovation',
      category: 'landscape',
      date: '2024-01-18',
      image: 'https://readdy.ai/api/search-image?query=Patio%20installation%20detail%2C%20stone%20patio%20work%2C%20hardscape%20construction%2C%20outdoor%20living%20space%2C%20professional%20patio%20installation&width=400&height=300&seq=43&orientation=landscape',
      description: 'Detailed view of custom patio installation'
    },
    {
      id: 7,
      title: 'Garden Bed Installation',
      project: 'Front Yard Landscaping',
      category: 'landscape',
      date: '2023-11-15',
      image: 'https://readdy.ai/api/search-image?query=Garden%20bed%20installation%2C%20flower%20bed%20planting%2C%20landscape%20design%20work%2C%20professional%20gardening%2C%20plant%20installation&width=400&height=300&seq=44&orientation=landscape',
      description: 'New garden beds with seasonal plantings'
    },
    {
      id: 8,
      title: 'Walkway Construction',
      project: 'Front Yard Landscaping',
      category: 'landscape',
      date: '2023-12-01',
      image: 'https://readdy.ai/api/search-image?query=Walkway%20construction%2C%20stone%20pathway%2C%20landscape%20hardscape%2C%20front%20yard%20walkway%2C%20professional%20pathway%20installation&width=400&height=300&seq=45&orientation=landscape',
      description: 'Custom stone walkway leading to front entrance'
    }
  ];

  const projects = [
    { id: 'all', label: 'All Projects' },
    { id: 'Backyard Renovation', label: 'Backyard Renovation' },
    { id: 'Front Yard Landscaping', label: 'Front Yard Landscaping' },
    { id: 'Kitchen Addition', label: 'Kitchen Addition' }
  ];

  const filteredItems = activeFilter === 'all' 
    ? portfolioItems 
    : portfolioItems.filter(item => item.project === activeFilter);

  if (!clientData) {
    return <div>Loading...</div>;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <Link to="/" className="flex items-center">
              <div className="w-10 h-10 bg-red-700 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-hammer-line text-white"></i>
              </div>
              <h1 className="text-xl font-bold text-red-700" style={{ fontFamily: '"Pacifico", serif' }}>
                Chavez Castro
              </h1>
            </Link>
            
            <nav className="flex space-x-6">
              <Link to="/client/dashboard" className="text-gray-600 hover:text-red-700">
                Dashboard
              </Link>
              <Link to="/client/portfolio" className="text-red-700 font-medium border-b-2 border-red-700">
                My Portfolio
              </Link>
              <Link to="/client/billing" className="text-gray-600 hover:text-red-700">
                Billing
              </Link>
            </nav>

            <div className="flex items-center space-x-4">
              <span className="text-gray-700">Welcome, {clientData.name}</span>
              <Button variant="outline" size="sm" onClick={handleLogout}>
                Logout
              </Button>
            </div>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Page Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">My Project Portfolio</h1>
          <p className="text-gray-600">View photos and progress of your completed and ongoing projects</p>
        </div>

        {/* Project Stats */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                <i className="ri-image-line text-blue-600 text-xl"></i>
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600">Total Photos</p>
                <p className="text-2xl font-bold text-gray-900">{portfolioItems.length}</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                <i className="ri-folder-line text-green-600 text-xl"></i>
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600">Projects</p>
                <p className="text-2xl font-bold text-gray-900">3</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center">
              <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center">
                <i className="ri-hammer-line text-yellow-600 text-xl"></i>
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600">Construction</p>
                <p className="text-2xl font-bold text-gray-900">1</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                <i className="ri-leaf-line text-green-600 text-xl"></i>
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600">Landscape</p>
                <p className="text-2xl font-bold text-gray-900">2</p>
              </div>
            </div>
          </div>
        </div>

        {/* Filter Buttons */}
        <div className="mb-8">
          <div className="flex flex-wrap gap-2">
            {projects.map((project) => (
              <button
                key={project.id}
                onClick={() => setActiveFilter(project.id)}
                className={`px-4 py-2 rounded-full font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  activeFilter === project.id
                    ? 'bg-red-700 text-white'
                    : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-300'
                }`}
              >
                {project.label}
              </button>
            ))}
          </div>
        </div>

        {/* Portfolio Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-product-shop>
          {filteredItems.map((item) => (
            <div key={item.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative">
                <img 
                  src={item.image}
                  alt={item.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="absolute top-4 left-4">
                  <span className={`inline-block px-3 py-1 text-sm font-medium text-white rounded-full ${
                    item.category === 'construction' ? 'bg-red-700' : 'bg-green-600'
                  }`}>
                    {item.category === 'construction' ? 'Construction' : 'Landscape'}
                  </span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-sm font-medium text-red-700 mb-2">{item.project}</p>
                <p className="text-gray-600 text-sm mb-4">{item.description}</p>
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-500">
                    <i className="ri-calendar-line mr-1"></i>
                    {new Date(item.date).toLocaleDateString()}
                  </span>
                  <Button variant="outline" size="sm">
                    <i className="ri-download-line mr-2"></i>
                    Download
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredItems.length === 0 && (
          <div className="text-center py-12">
            <i className="ri-image-line text-6xl text-gray-300 mb-4"></i>
            <h3 className="text-lg font-medium text-gray-900 mb-2">No photos found</h3>
            <p className="text-gray-600">No photos available for the selected project filter.</p>
          </div>
        )}

        {/* Download All */}
        {filteredItems.length > 0 && (
          <div className="mt-8 text-center">
            <Button size="lg">
              <i className="ri-download-cloud-line mr-2"></i>
              Download All Photos
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

